import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest('post', `/api/live_discussions/${liveID}/restart`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/restart.js